<script>
  import queryString from 'query-string';

  import { onMount, createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';
  import { apiGet } from '../httpCommon';
  import moment from 'moment';
  import Card, { PrimaryAction, Content, Media } from '@smui/card';
  import Button, { Label } from '@smui/button';
  import Carousel from '@beyonk/svelte-carousel';

  import Basket from '../components/Basket.svelte';
  import Menu from '../components/Menu.svelte';
  import CustomerLocationBox from '../components/CustomerLocationBox.svelte';
  import NewsLetterSignup from '../components/NewsLetterSignup.svelte';

  let carousel;
  let prevButton = true;
  let nextButton;

  function left(e) {
    carousel.left();
  }

  function right(e) {
    carousel.right();
  }

  function carouselChange(e) {
    const { currentSlide } = e.detail;
    const popups = document.querySelectorAll('.slides > div > div').length;

    currentSlide === 0 ? (prevButton = true) : (prevButton = false);
    currentSlide + 1 === popups ? (nextButton = true) : (nextButton = false);
  }

  const emit = createEventDispatcher();

  export let slug;

  let result;

  let searching = false;
  let place;
  let selectedPopup;
  let order;
  let basket;
  let orders = {};
  let slideCount;

  function selectPopup(popup) {
    if (selectedPopup != popup) {
      selectedPopup = null;
      setTimeout(() => {
        selectedPopup = popup;
        order = orders[selectedPopup.id];
      }, 100);
    }
  }

  function onOrderUpdated(ev) {
    orders = ev.detail;
    if (selectedPopup) {
      order = orders[selectedPopup.id];
    } else {
      order = {};
    }
  }

  let fd_email_address;

  onMount(async () => {
    try {
      searching = true;
      result = await apiGet(['venues', slug, 'popups']);
      if (result && result.popups && result.popups.length > 0) {
        const queryParams = queryString.parse(window.location.search);
        let popup = null;
        if (queryParams.popup_id) {
          popup = Object.values(result.popups).filter((p) => p.id == queryParams.popup_id)[0];
        }
        if (!popup) {
          popup = result.popups[0];
        }
        fd_email_address = popup.fd_email_address;
        selectPopup(popup);
      }
      matchWidths();
      // check_single_use_voucher();
    } finally {
      searching = false;
    }
  });

  function groupPopups(popups) {
    const sortPopups = popups.reduce((a, e) => {
      let key = moment(e.start_time).format('YYYY-MM-DD');

      (a[key] ? a[key] : (a[key] = null || [])).push(e);
      return a;
    }, {});

    return Object.entries(sortPopups);
  }

  function matchWidths() {
    if (window.innerWidth <= 767) {
      return;
    }

    setTimeout(() => {
      const popUpGroups = document.querySelectorAll('.popup__group ');

      popUpGroups.forEach((group) => {
        const flex = group.style.flex;
        group.parentElement.style.flex = `${flex}`;
      });
    }, 20);
  }

  window.onresize = matchWidths;

  const VOUCER_CODE = 'HELLO'; // Need to change to pull in from the DB
  let VOUCHER_FIELD_AVAILABLE;

  function check_single_use_voucher() {
    console.log('venue voucher');
    const fd_local_options = localStorage.getItem('fd_opts');
    if (fd_local_options) {
      fd_local_options.includes(VOUCER_CODE) ? (VOUCHER_FIELD_AVAILABLE = true) : (VOUCHER_FIELD_AVAILABLE = false);
    }
  }
</script>

<div class="outer">
  <div class="container">
    {#if searching}
      <h3 class="error-info">Searching...</h3>
    {:else if !result || !result.popups}
      <h3 class="error-info">
        Location not found
        <a href="/">Search again</a>
      </h3>
    {:else if result.popups.length == 0}
      <h3 class="error-info">No popups found, please check back again soon</h3>
    {:else}
      <NewsLetterSignup venueId={result.venue.id} />
      <div class="popups">
        {#if result.popups.length > 1}
          <div class="carousel-controls">
            <button class="carousel-control carousel-control--prev {prevButton ? 'carousel-control--hidden' : ''}" on:click={left} aria-label="Cycle vendors left">
              <img src="/chevron.svg" alt="Chevron left" />
            </button>
            <button class="carousel-control carousel-control--next {nextButton ? 'carousel-control--hidden' : ''}" on:click={right} aria-label="Cycle vendors right">
              <img src="/chevron.svg" alt="Chevron right" />
            </button>
          </div>
        {/if}

        <Carousel
          bind:this={carousel}
          on:change={carouselChange}
          perPage={{
            768: groupPopups(result.popups).length,
            100: 1,
          }}
          loop={false}
          controls={false}
          dots={false}
          draggable={false}
        >
          {#each groupPopups(result.popups) as popup}
            <div class="popup__group" style="flex: {popup[1].length}">
              <div class="popup__group-header">
                <span class="day day--desk">{moment(popup[0]).format('dddd')}&nbsp;-&nbsp;</span>
                <span class="day day--mob">{moment(popup[0]).format('ddd')}&nbsp;-&nbsp;</span>
                <span class="date">{moment(popup[0]).format('DD/MM')}</span>
              </div>
              <div class="popup__group-popups">
                {#each popup[1] as indPopup}
                  <div class="popup__group-popup" class:selected={indPopup == selectedPopup} on:click={() => selectPopup(indPopup)}>
                    <div>
                      <span class="venue-name">{indPopup.vendor_name}</span>
                    </div>
                    <div class="time">
                      <span class="start-time"
                        >{moment(indPopup.start_time).format('HH:mm')}
                        -
                      </span>
                      <span class="end-time">{moment(indPopup.end_time).format('HH:mm')} </span>
                    </div>
                  </div>
                {/each}
              </div>
            </div>
          {/each}
        </Carousel>
      </div>
    {/if}

    {#if selectedPopup}
      <div transition:fade id={selectedPopup.id} class="vendor-image" style="background: url({selectedPopup.menu_image}) left/cover" />
    {/if}

    <div class="menu-container">
      {#if result && result.popups && result.popups.length > 0 && selectedPopup}
        <Basket bind:this={basket} on:orderupdated={onOrderUpdated} venue={result.venue} popup={selectedPopup ? selectedPopup : 'hello'} voucherCodeUsed={VOUCHER_FIELD_AVAILABLE} fdEmailAddress={fd_email_address} />
      {/if}
      {#if selectedPopup}
        <Menu popup={selectedPopup} {basket} {order} venue={result.venue} />
      {/if}
    </div>

    {#if selectedPopup}
      <div class="footer">
        <hr class="separator" />
        <h4>Allergy information</h4>
        <div class="warning">
          Please note that all dishes may contain traces of the following allergens: cereals containing gluten, crustaceans, eggs, fish, peanuts, soybeans, dairy, nuts, celery, mustard, sesame, sulphur dioxide/sulphites, lupin and molluscs. For any
          questions regarding the allergen contents of specific dishes please contact the appropriate event's food partner on the phone number provided. All allergen advice is provided by the vendor and cannot be guaranteed by Food Disco.
        </div>
        <div class="warning">Unless otherwise indicated, alcoholic beverages are sold by Food Disco Limited.</div>
      </div>
    {/if}
  </div>
</div>

<style type="text/scss">
  .popup__group {
    display: flex;
    flex-direction: column;
  }

  .popup__group-header {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #3d3b3b;
    // padding: 8px 0;
    color: #ffffff;
    border-right: 2px solid #ffffff;
    margin-bottom: 5px;
    height: 45px;
  }

  .popup__group-header:nth-of-type(3) {
    border-right: 2px solid green;
  }

  .popup__group-header span {
    font-family: Manrope;
    font-weight: bold;
  }

  .popup__group-popups {
    display: flex;
    height: 100%;
  }

  .popup__group-popup {
    flex: 1;
    text-align: left;
    cursor: pointer;
    background: #f2f2f2;
    border: 3px solid transparent;
    transition: border 0.2s ease-in-out;
    border-radius: 0;
    padding: 8px 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    margin: 0;
    width: 100%;
  }

  .popup__group-popup:hover {
    border: 3px solid #6ac8d9;
  }

  .popup__group-popup.selected {
    border: 3px solid #eb4624;
    background: #eb4624;
    color: #ffffff;
  }

  .outer {
    width: 922px;
    margin: auto;
    position: relative;
  }

  @media screen and (max-width: 922px) {
    .outer {
      width: 96%;
    }
  }

  @media screen and (max-width: 570px) {
    .outer {
      width: 90%;
    }
  }

  .container {
    margin-top: 20px;
    align-items: center;
    max-width: 1050px;
  }

  @media screen and (max-width: 767px) {
    .container {
      margin-top: 0;
    }
  }

  .vendor-image {
    width: 922px;
    height: 240px;
    position: relative;
  }

  @media screen and (max-width: 922px) {
    .vendor-image {
      width: 100%;
    }
  }

  .order-column {
    width: 313px;
  }
  .menu-column {
    margin-left: 29px;
    width: 580px;
  }

  .separator {
    margin-top: 36px;
    margin-bottom: 47px;
  }

  .warning {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 140%;
    /* or 20px */
    letter-spacing: -0.01em;
    text-align: left;
    margin-bottom: 20px;
  }

  .footer {
    width: 100%;
    margin-bottom: 20px;
  }

  .error-info {
    width: 100%;
    text-align: center;
    margin-top: 100px;
  }

  h4 {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
  }

  .popups {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
    position: relative;
  }

  .popups :global(.slides > div) {
    display: flex;
    // justify-content: space-between;
  }
  .popups :global(.slides > div > div) {
    // width: auto !important;
    display: flex;
  }

  @media screen and (max-width: 768px) {
    .popups :global(.slides > div > div) {
      width: 100% !important;
    }
  }

  .carousel-controls {
    display: flex;
    height: 50px;
  }

  @media screen and (min-width: 768px) {
    .carousel-controls {
      display: none;
    }
  }

  .popups :global(.carousel) {
    border-bottom: 5px solid #eb4624;
  }

  .carousel-control {
    display: flex;
    align-items: center;
    width: 50%;
    background: transparent;
    border: none;
    padding: 10px 0;
    margin: 0;
  }

  .carousel-control--hidden {
    opacity: 0.1;
  }

  .carousel-control span {
    font-family: Manrope !important;
    font-size: 14px;
    font-style: normal;
    font-weight: bold;
  }

  .carousel-control--prev {
    justify-content: flex-start;
  }

  .carousel-control--next {
    justify-content: flex-end;
  }

  .carousel-control--prev img {
    transform: translateX(-8px);
  }

  .carousel-control--next img {
    transform: rotate(180deg) translateX(-8px);
  }

  .day-date {
    margin-top: auto;
    margin-bottom: -3px;
  }

  .popup__group-popups .venue-name,
  .popup__group-popups .day,
  .popup__group-popups .date,
  .popup__group-popups .start-time,
  .popup__group-popups .end-time {
    font-family: Manrope;
    font-style: normal;
    display: inline-block;
    font-size: 14px;
  }

  .popup__group-popups .venue-name {
    font-weight: bold;
    display: block;
  }
  .popup__group-popups .time {
    margin-top: auto;
  }

  .day--mob {
    display: none !important;
  }

  @media only screen and (max-width: 845px) {
    .day--desk {
      display: none !important;
    }
    .day--mob {
      display: inline-block !important;
    }
  }

  /****************
    Menu and basket section
  ****************/
  .menu-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 58px;
    width: 100%;
  }

  .order-column {
    width: 40%;
  }

  .menu-column {
    width: 60%;
  }

  @media screen and (max-width: 768px) {
    .menu-container {
      flex-direction: column-reverse;
    }
    .order-column {
      width: 100%;
    }
    .menu-column {
      width: 100%;
      margin-left: 0;
    }
  }

  .news-letter {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .news-letter__title {
    font-size: 28px;
    text-align: center;
  }

  @media screen and (max-width: 520px) {
    .news-letter__title {
      font-size: 18px;
    }
  }

  .news-letter__form {
    display: flex;
    margin: 22px 0;
  }

  @media screen and (max-width: 520px) {
    .news-letter__form {
      flex-direction: column;
    }
  }

  .news-letter__input {
    margin: 0 20px 0 0;
    width: 300px;
    border-radius: 0;
    font-size: 16px;
    padding: 8px;
    border: 3px solid rgba(61, 59, 59, 1);
  }

  @media screen and (max-width: 520px) {
    .news-letter__input {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  .news-letter :global(button) {
    margin: 0 !important;
    height: auto;
  }

  .signup__terms-text {
    margin: 0 auto;
    display: block;
    text-align: center;
    font-size: 12px;
  }

  .signup__terms-link {
    text-decoration: underline;
    font-weight: bold;
  }
</style>
